import { forwardRef } from 'react';
import { useId } from 'react-id-generator';
import { cssShorthandPropsFilter, Spacer } from '../../primitives/Spacer/index.js';
import { Label } from '../Label/index.js';
import { Message } from '../Message/index.js';
import { StyledTextarea } from './styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const Textarea = forwardRef(({
  ['data-testid']: dataTestId,
  error,
  disabled,
  id,
  label,
  message,
  resize = 'vertical',
  size = 'md',
  ...props
}, ref) => {
  const [uniqueId] = useId(1, 'textarea-');
  const hasError = Boolean(error);
  const textareaId = id || uniqueId;
  const textareaProps = cssShorthandPropsFilter(props, true);
  const hasMessage = Boolean(message) || Boolean(error);
  return jsxs(Spacer, {
    "data-testid": dataTestId,
    ...cssShorthandPropsFilter(props),
    children: [jsx(Label, {
      disabled: disabled,
      htmlFor: textareaId,
      mb: 1,
      children: label
    }), jsx(StyledTextarea, {
      "aria-describedby": hasMessage ? `${textareaId}-message` : null,
      hasError: hasError,
      id: textareaId,
      ref: ref,
      resize: resize,
      size: size,
      ...textareaProps
    }), hasMessage && jsx(Message, {
      disabled: disabled,
      error: error,
      id: `${textareaId}-message`,
      message: message
    })]
  });
});

export { Textarea };
